import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingHomePageService } from './fi-onboarding-home-page.service';
import { FiOnboardingHomePageComponent } from './fi-onboarding-home-page/fi-onboarding-home-page.component';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiOnboardingCompletionModule } from '@fi-app/fi-onboarding/fi-onboarding-completion/fi-onboarding-completion.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiMultipleOnboardingsCardComponent } from './fi-multiple-onboardings-card/fi-multiple-onboardings-card.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiSingleOnboardingCardComponent } from './fi-single-onboarding-card/fi-single-onboarding-card.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
@NgModule({
    imports: [
        CommonModule,
        FiMatIconCheckboxMenuModule,
        FiOnboardingCompletionModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiLoadingModule,
    ],
    declarations: [FiOnboardingHomePageComponent, FiMultipleOnboardingsCardComponent, FiSingleOnboardingCardComponent],
    providers: [FiOnboardingHomePageService],
    exports: [FiOnboardingHomePageComponent],
})
export class FiOnboardingHomePageModule {}
